import { searchAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

export default {
  async fetchRecentSearchKeyword({ commit }, payload) {
    const { data } = await ServiceExec.get(
      searchAPI.recentSearchKeyword,
      payload
    );
    commit('setRecentSearchKeyword', data);
  },

  // 인기검색어 반영 & Store에 최근 검색어 추가
  saveKeywordCollection({ commit }, keyword) {
    const { data } = ServiceExec.post(searchAPI.save_keywordCollection, {
      keyword
    });
    commit('setRecentSearchKeyword', keyword);
    return data;
  },

  async fetchRecommendedKeyword({ commit }, payload) {
    const { data } = await ServiceExec.get(
      searchAPI.recommendedKeyword,
      payload
    );
    commit('setRecommendedKeyword', data);
  },

  async fetchKeywordRank({ commit }, payload) {
    const { data } = await ServiceExec.get(searchAPI.keywordRank, payload);
    commit('setKeywordRank', data);
  }
};
